
// Deprecated, will be replaced by components/controls/IconButton
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import {noop} from 'components/helpers/funcTools';
import commonStyles from 'styles/common.scss';
import styles from './IconButton.scss';

function IconButton(props) {
    const {
        className,
        onClick,
        children,
        isAdornment,
        type,
    } = props;

    const buttonClassName = classnames(className, styles.button, commonStyles.flexCenterContent, {
        [styles.adornment]: isAdornment,
    });
    return (
        <button type={type} className={buttonClassName} onClick={onClick}>
            {children}
        </button>
    );
}

IconButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    isAdornment: PropTypes.bool,
    type: PropTypes.string,
};

IconButton.defaultProps = {
    className: '',
    onClick: noop,
    children: null,
    isAdornment: false,
    type: 'button',
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/controls/buttons/IconButton/IconButton.jsx